import React from "react"; //, {useState} 
import { Link } from 'react-router-dom';

import './Sidebar.css';

const SideBarItem = ({ item, active }) => {
    // const [hover, setHover] = useState(false);
    const userAuth = localStorage.getItem('auth');

    if(item.id === 5 && userAuth !== 'Superadmin') {
        return null;
    }

    return (
        <Link 
            to={item.path} 
            className={active ? 'sidebar-item-active' : 'sidebar-item'} >
                <img 
                    src={item.icon}
                    alt={`icon-${item.icon}`}
                    className='sidebar-item-icon' />
                <span className='sidebar-item-label'>{item.title}</span>
        </Link>
    )
}
export default SideBarItem;
